import confirm from '../../../utils/confirm.jsx';

export function request(bannerId) {
    return confirm('Are you sure you want to delete this banner ?', {
        type: 'DELETE_BANNER_REQUEST',
        bannerId
    });
}

export function error(errors) {
    return {
        type: 'DELETE_BANNER_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'DELETE_BANNER_FINISH',
        data
    };
}
